










import { Component, Vue } from "vue-property-decorator";
import Header from "@/components/header/UHeader.vue";
import PreRegisterForm from "@/components/forms/PreRegisterForm.vue";
import Footer from "@/components/Footer.vue";

@Component({
  components: {
    Header,
    PreRegisterForm,
    Footer,
  },
})
export default class UPreRegister extends Vue {}
